import { type LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import {
  SidebarGroup,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarSeparator,
} from '@/components/ui/sidebar';

export function NavMain({
  sections,
}: {
  sections: {
    items: {
      title: string;
      url: string;
      icon?: LucideIcon;
    }[];
  }[];
}) {
  return (
    <>
      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          <SidebarGroup>
            <SidebarMenu>
              {section.items.map((item) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    asChild
                    className="group-hover:group-data-[collapsible=icon]:!h-8 group-data-[collapsible=icon]:!h-8 group:hover[data-collapsible=icon]:!h-8 group-hover:group-data-[collapsible=icon]:!h-8 !h-8"
                  >
                    <Link to={item.url}>
                      {item.icon && <item.icon />}
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroup>
          {sectionIndex < sections.length - 1 && <SidebarSeparator />}
        </div>
      ))}
    </>
  );
}
